import React, { useState, useEffect } from "react";
import axiosInstance from "../../config/axiosInterceptor";

// Replace with your actual API endpoint
const baseUrl5 = process.env.REACT_APP_BASEURL5;


const FamilyHistory = () => {
    const [histories, setHistories] = useState([]);
    const [entriesPerPage, setEntriesPerPage] = useState(10);
    const [page, setPage] = useState(1);
    const [totalEntries, setTotalEntries] = useState(0);
    const [searchType, setSearchType] = useState("username");
    const [search, setSearch] = useState("");
    const [startDate, setStartDate] = useState(() => new Date().toISOString().slice(0, 10));
    const [endDate, setEndDate] = useState(() => new Date().toISOString().slice(0, 10));
    const [show, setShow] = useState(false); // Only fetch when apply clicked
    const [loading, setLoading] = useState(false);

    const totalPages = Math.ceil(totalEntries / entriesPerPage);

    const fetchHistories = async () => {
        setLoading(true);
        try {
            const params = new URLSearchParams({
                page,
                limit: entriesPerPage,
                ...(show && {
                    searchType,
                    search,
                    startDate,
                    endDate,
                }),
            });
            const {data} = await axiosInstance(`${baseUrl5}/admin/familyImage/getFamilyHistories?${params}`);
            if (data.success) {
                setHistories(data.histories);
                setTotalEntries(data.totalEntries);
            }
        } catch (err) {
            alert("Error fetching histories");
        }
        setLoading(false);
    };

    useEffect(() => {
        fetchHistories();
        // eslint-disable-next-line
    }, [page, entriesPerPage, show]);

    // Styling
    const containerStyle = {
        maxWidth: 900,
        margin: "40px auto",
        background: "linear-gradient(135deg,#f6f8fc 60%, #e3eafc 100%)",
        borderRadius: 20,
        boxShadow: "0 2px 12px 0 rgba(100, 120, 150, 0.15)",
        padding: 32,
        fontFamily: "Inter, sans-serif",
    };
    const headerStyle = {
        fontSize: 32,
        fontWeight: 700,
        marginBottom: 18,
        letterSpacing: "0.03em",
        color: "#395886",
        textAlign: "center",
    };
    const inputStyle = {
        borderRadius: 8,
        border: "1px solid #e0e5ed",
        padding: "8px 10px",
        marginRight: 14,
        fontSize: 16,
        minWidth: 160,
        background: "#fff"
    };
    const selectStyle = {
        ...inputStyle,
        minWidth: 100
    };
    const btnStyle = {
        borderRadius: 8,
        background: "#4a69bd",
        color: "#fff",
        border: "none",
        padding: "10px 22px",
        fontSize: 16,
        cursor: "pointer",
        marginLeft: 16,
        boxShadow: "0 1px 4px rgba(0,0,0,0.05)"
    };
    const tableStyle = {
        width: "100%",
        marginTop: 28,
        borderCollapse: "collapse",
        fontSize: 15,
    };
    const thtd = {
        padding: "12px 8px",
        borderBottom: "1px solid #e8e8e8",
        textAlign: "left",
    };
    const captionStyle = {
        fontWeight: 500,
        marginBottom: 10,
        color: "#5a6780",
    };
    const navBtn = {
        ...btnStyle,
        padding: "7px 15px",
        margin: 0,
        fontSize: 15,
        background: "#c3d0ee",
        color: "#395886"
    };
    const badge = {
        background: "#6a89cc",
        color: "#fff",
        fontSize: 13,
        borderRadius: 6,
        padding: "3px 10px",
        fontWeight: 500,
        marginRight: 6,
    };

    return (
        <div style={containerStyle}>
            <div style={headerStyle}>Family History</div>

            {/* Top Controls */}
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 18 }}>
                <div>
                    <span style={captionStyle}>Entries per page:</span>
                    <select
                        style={selectStyle}
                        value={entriesPerPage}
                        onChange={e => { setEntriesPerPage(Number(e.target.value)); setPage(1); }}
                    >
                        {[10, 50, 100, 200].map(n => (
                            <option key={n} value={n}>{n}</option>
                        ))}
                    </select>
                    <span style={captionStyle}>Total entries: <b>{totalEntries}</b></span>
                </div>
                <div>
                    <button
                        style={navBtn}
                        onClick={() => setPage(p => Math.max(1, p - 1))}
                        disabled={page === 1}
                    >Prev</button>
                    <span style={{ margin: "0 8px" }}>{page} / {totalPages || 1}</span>
                    <button
                        style={navBtn}
                        onClick={() => setPage(p => Math.min(totalPages, p + 1))}
                        disabled={page === totalPages || totalPages === 0}
                    >Next</button>
                </div>
            </div>

            {/* Filters */}
            <div style={{
                display: "flex", alignItems: "center",
                flexWrap: "wrap", marginBottom: 16,
                gap: 14
            }}>
                <select style={selectStyle} value={searchType} onChange={e => setSearchType(e.target.value)}>
                    <option value="username">Search by Username</option>
                    <option value="family">Search by Family</option>
                </select>
                <input
                    style={inputStyle}
                    placeholder="Search"
                    value={search}
                    onChange={e => setSearch(e.target.value)}
                />
                <input
                    style={inputStyle}
                    type="date"
                    value={startDate}
                    onChange={e => setStartDate(e.target.value)}
                />
                <input
                    style={inputStyle}
                    type="date"
                    value={endDate}
                    onChange={e => setEndDate(e.target.value)}
                />
                <button style={btnStyle} onClick={() => { setShow(s => !s); setPage(1); }}>
                    Apply Filters
                </button>
            </div>

            {/* Table */}
            <table style={tableStyle}>
                <thead>
                    <tr style={{ background: "#f1f5fa" }}>
                        <th style={thtd}>#</th>
                        <th style={thtd}>Username</th>
                        <th style={thtd}>Family Name</th>
                        <th style={thtd}>Type</th>
                        <th style={thtd}>Message</th>
                        <th style={thtd}>Date</th>
                    </tr>
                </thead>
                <tbody>
                    {loading ?
                        <tr><td colSpan={6} style={{ textAlign: "center", color: "#888" }}>Loading...</td></tr>
                        : histories.length === 0 ?
                            <tr><td colSpan={6} style={{ textAlign: "center", color: "#888" }}>No data found</td></tr>
                            : histories.map((h, i) => (
                                <tr key={h._id}>
                                    <td style={thtd}>{(page - 1) * entriesPerPage + i + 1}</td>
                                    <td style={thtd}>{h.userId?.username ?? "-"}</td>
                                    <td style={thtd}>{h.familyId?.name ?? "-"}</td>
                                    <td style={thtd}><span style={badge}>{h.type}</span></td>
                                    <td style={thtd}>{h.message}</td>
                                    <td style={thtd}>{new Date(h.createdAt).toLocaleString()}</td>
                                </tr>
                            ))
                    }
                </tbody>
            </table>
        </div>
    );
};

export default FamilyHistory;
